/* eslint-disable */
import { useEffect } from "react";
import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
} from "react-query";
import { useProgress } from "../useProgress";

export const useInfiniteQueryWithLoading = <TResult, TError>(
  queryKey: string | string[],
  queryFn: (context: { pageParam?: number }) => Promise<TResult>,
  options: Omit<
    UseInfiniteQueryOptions<
      TResult,
      TError,
      TResult,
      TResult,
      readonly unknown[]
    >,
    "queryKey" | "queryFn"
  >
): UseInfiniteQueryResult<TResult, TError> => {
  const { toggleLoading } = useProgress();

  const queryResult = useInfiniteQuery(
    [queryKey] as readonly unknown[],
    queryFn,
    {
      ...options,
      onSettled: () => {
        toggleLoading(false);
      },
      getPreviousPageParam: (firstPage: any, pages) => {
        const currentPage = firstPage.page || 1;
        return currentPage > 1 ? currentPage - 1 : undefined;
      },
      getNextPageParam: (lastPage: any, pages) => {
        const currentPage = lastPage.page || 1;
        const totalPages = lastPage.count;
        return currentPage < totalPages ? currentPage + 1 : undefined;
      },
    }
  );

  const isLoading = queryResult.isLoading;

  useEffect(() => {
    if (isLoading !== undefined) {
      toggleLoading(isLoading);
    }
  }, [isLoading, toggleLoading]);

  return queryResult;
};
